// Pantalla `command="login-config-totp"`. Port de la rama `when
// "login-config-totp"` de keycloak.coffee. Form de configuración 2FA
// con app autenticadora: input código + nombre dispositivo, instrucciones
// con apps recomendadas y QR. Si es AIA, botón Cancelar.

import type { FormEvent } from "react";
import type { KcData } from "../kcData";
import { Input } from "../components/Input";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface TotpData {
  secret: string;
  secretQrCode: string;
  secretEncoded: string;
}

function getTotp(data: KcData): TotpData | undefined {
  return (
    (data.form?.totp as TotpData | undefined) ??
    (data as unknown as { totp?: TotpData }).totp
  );
}

export interface LoginConfigTotpPageProps {
  data: KcData;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

export function LoginConfigTotpPage(props: LoginConfigTotpPageProps) {
  const { data, onSubmit } = props;
  const totp = getTotp(data);

  return (
    <StandardPage page="login-config-totp" data={data}>
      <form
        id="kc-totp-settings-form"
        action={data.url!.loginAction}
        method="post"
        onSubmit={onSubmit}
      >
        <div className="form-group">
          <label htmlFor="totp">{msg("totpCode")}</label>
          <Input
            type="text"
            id="totp"
            name="totp"
            className="form-control text-center"
            autoFocus
            placeholder={msg("totpCode")}
            messagesPerField={data.messagesPerField}
          />
          <input
            type="hidden"
            id="totpSecret"
            name="totpSecret"
            value={totp?.secret ?? ""}
          />
        </div>
        <div className="form-group">
          <label htmlFor="userLabel">{msg("totpUserLabel")}</label>
          <Input
            type="text"
            id="userLabel"
            name="userLabel"
            className="form-control text-center"
            placeholder={msg("totpUserLabel")}
            messagesPerField={data.messagesPerField}
            helpText={msg("totpUserLabelHelp")}
          />
          <button
            type="submit"
            id="kc-login"
            className="btn btn-lg btn-block btn-primary"
          >
            {msg("doSubmit")}
          </button>
          {data.isAppInitiatedAction ? (
            // OJO: sin disabled / onClick — ver nota en
            // LoginUpdatePasswordPage.tsx. En React 18 un setState en
            // onClick deshabilita el botón antes del submit y se pierde
            // el par cancel-aia=true en el POST.
            <button
              type="submit"
              name="cancel-aia"
              value="true"
              className="btn btn-lg btn-block btn-default"
            >
              {msg("doCancel")}
            </button>
          ) : null}
        </div>
        <ol id="kc-totp-settings" className="totp-settings">
          <li>
            {/* Step 1 contiene 4 enlaces inline a las apps; usamos
                dangerouslySetInnerHTML porque el mensaje es totalmente
                controlado por el theme (sin input de usuario, sin XSS). */}
            <p dangerouslySetInnerHTML={{ __html: msg("totpStep1Html") }} />
          </li>
          <li>
            <p>{msg("loginTotpStep2")}</p>
            {totp?.secretQrCode ? (
              <img src={`data:image/png;base64, ${totp.secretQrCode}`} alt="QR" />
            ) : null}
            <p>
              <span className="code">{totp?.secretEncoded}</span>
            </p>
          </li>
          <li>
            <p>{msg("totpStep3")}</p>
          </li>
        </ol>
      </form>
    </StandardPage>
  );
}
